export enum WaypointStatus {
  Discharged = 'discharged',
  Fail = 'failedToDischarge',
  NotDone = 'notDone',
}

export interface IExtraService {
  date: string;
  name: string;
  quantity: number;
}
